import styled from "styled-components";
import { FormSection, FormRow, FormField, FormLabel, FormInput, FormSelect } from "@/screen/Identities/Styles/IdentityFormStyles";
import { QuestionText, RadioGroup, RadioLabel, RadioInput, DisclaimerBox, SearchableSelectWrapper } from "@/screen/Identities/IdentityFiscalInputs/Styles/IdentityFiscalInputsStyles";
export { FormSection, FormRow, FormField, FormLabel, FormInput, FormSelect, QuestionText, RadioGroup, RadioLabel, RadioInput, DisclaimerBox, SearchableSelectWrapper };

/** Tarjeta de una fila de actividad económica (cuenta ajena / cuenta propia). */
export const ActivityCard = styled.div`
    border: 1px solid ${(props) => props.theme?.palette?.inputBorder ?? "#d1d9db"};
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
`;

export const ActivityCardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;

    span
    {
        font-size: 13px;
        font-weight: 600;
        color: #2a4143;
    }
`;

export const ActivityRemoveButton = styled.button`
    background: transparent;
    border: 1px solid #a4262c;
    color: #a4262c;
    border-radius: 6px;
    padding: 4px 12px;
    font-size: 12px;
    cursor: pointer;

    &:hover
    {
        background-color: #fdf3f4;
    }

    &:disabled
    {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const ActivityAddButtonRow = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 8px;
`;

export const ActivityAddButton = styled.button`
    background: transparent;
    border: 1px dashed ${(props) => props.theme?.palette?.themePrimary ?? "#CC214F"};
    color: ${(props) => props.theme?.palette?.themePrimary ?? "#CC214F"};
    border-radius: 8px;
    padding: 8px 16px;
    font-size: 13px;
    cursor: pointer;

    &:hover
    {
        background-color: rgba(204, 33, 79, 0.06);
    }

    &:disabled
    {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

/** Mensaje de error/bloqueo anclado bajo un campo concreto (errores del servidor KYC_*). */
export const InlineFieldError = styled.p`
    color: #a4262c;
    font-size: 12px;
    margin-top: 6px;
    line-height: 1.4;
`;

export const SubQuestionIndent = styled.div`
    margin-top: 12px;
`;

/** Aviso de bloque de actividades contestado "Sí" pero sin ninguna fila añadida.
 *  Usa el tono ámbar del resalte de campos pendientes (no es un error del servidor). */
export const PendingActivitiesHint = styled.p`
    font-size: 13px;
    color: #8a6100;
    margin: 0;
    line-height: 1.4;
`;
